import "./About.module.css";
import Navigation from "@/reusable_sections/Header";
import Craftsmanship from "./sections/Craftsmanship";
import Philosophy from "./sections/Philosophy";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Navigation />
      <Craftsmanship />
      <Philosophy />
      <Footer />
    </div>;
}